import {useNavigate, useSearchParams} from "react-router-dom";
import {serviceEventSelector, useGetServiceEventQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {ServiceEventProfile} from "../../components/profile/ServiceEventProfile/ServiceEventProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const ServiceEventProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.serviceevent", "Service Event") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <ServiceEventProfilePage id={id}/>;
};

export const ServiceEventProfilePage = (props: Props) => {
  const {id} = props;

  const [access, setAccess] = useState(false);

  const selectServiceEvent = useMemo(() => {
    return serviceEventSelector()
  }, []);

  const {serviceEvent, isFetching} = useGetServiceEventQuery(access ? (id ?? skipToken) : skipToken, {
    selectFromResult: (result) => ({
      serviceEvent: selectServiceEvent(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage
      permissions={["serviceevent_view"]}
      entity={serviceEvent}
      isLoading={isFetching}
      onAccess={setAccess}>
      {(entity) => (
        <ServiceEventProfile serviceEvent={entity}/>
      )}
    </EntityProfilePage>
  )
};
